import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=70edabd5&"
import script from "./Chip.vue?vue&type=script&lang=js&"
export * from "./Chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70edabd5')) {
      api.createRecord('70edabd5', component.options)
    } else {
      api.reload('70edabd5', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=70edabd5&", function () {
      api.rerender('70edabd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Chip.vue"
export default component.exports